











import { defineComponent, computed } from '@vue/composition-api';
import { INavigationLinkProps, ILinkBindings } from './types';

export default defineComponent({
  name: 'NavigationLink',
  props: {
    trackingId: {
      type: String,
      default: '',
    },
    linkType: {
      type: String,
      default: 'a',
    },
    urlPath: {
      type: String,
      required: true,
    },
    openNewTab: {
      type: Boolean,
      default: false,
    },
  },
  setup(props: INavigationLinkProps) {
    const elementName = computed(() => {
      if (props.linkType) return props.linkType === 'story' ? 'NuxtLink' : 'a';

      return 'a';
    });
    const bindings = computed(() => {
      const linkBindings: ILinkBindings = {};

      if (props.linkType === 'story') {
        linkBindings.to = `/${props.urlPath}`;
      } else if (props.linkType === 'url') {
        linkBindings.href = props.urlPath;
      }

      if (props.openNewTab) { linkBindings.rel = 'noopener'; linkBindings.target = '_blank'; }

      return linkBindings;
    });

    const isValid = computed(() => elementName.value && !!Object.keys(bindings.value).length);

    return {
      elementName,
      bindings,
      isValid,
    };
  },
});
